export default __webpack_public_path__ + "static/media/f939679add25a2dd.3244c8f2f674985ebcd7761bac8c0db8.svg";